import React, { CSSProperties } from 'react';

import { cn } from '../helpers/cn';

export type DotSeparatedLabelProps = {
    className?: string;
    classNameLabel?: string;
    classNamePrimaryLabel?: string;
    classNameDot?: string;
    multiline?: boolean;
    labels: (string | React.JSX.Element | null | undefined)[];
    style?: CSSProperties;
    parentElement?: 'span' | 'div';
    /** `before` puts the dot at the start of each following label, so a wrapped row never ends in a dangling dot. */
    dotPosition?: 'after' | 'before';
    /** With `before`, also dots the first label; the caller clips it so wrapped lines start flush. */
    leadingDot?: boolean;
};

function DotSeparatedLabel(props: DotSeparatedLabelProps): React.JSX.Element {
    const {
        className,
        style,
        classNameLabel,
        classNamePrimaryLabel,
        classNameDot,
        labels: labelProps,
        multiline = true,
        dotPosition = 'after',
        leadingDot = false
    } = props;
    const filteredLabels = labelProps.filter((label) => label !== undefined && label !== '' && label !== null);
    const ParentElement = props.parentElement === 'span' ? 'span' : 'div';
    const dot = <span className={cn(classNameDot, 'px-4 lg:px-6', multiline !== true ? '' : 'inline-block')}>·</span>;
    return (
        <ParentElement
            className={cn(className, 'items-center', multiline !== true ? '' : 'flex flex-wrap')}
            style={style}>
            {filteredLabels.map((label, index) => (
                <span
                    key={`label#${index}`}
                    className={cn(
                        multiline !== true ? '' : 'inline-flex',
                        index === 0 && classNamePrimaryLabel ? classNamePrimaryLabel : classNameLabel
                    )}>
                    {dotPosition === 'before' && (index > 0 || leadingDot) && dot}
                    {label}
                    {dotPosition === 'after' && index < filteredLabels.length - 1 && dot}
                </span>
            ))}
        </ParentElement>
    );
}

export default DotSeparatedLabel;
